module.exports = "pegasus/assets/theme4/small/6.jpg";